/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.moudle';
import { CommonModule } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { PASSWORD_MIN_LENGTH } from '../../../data-models/user-login';

@Component({
  selector: 'app-delete-info',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './delete-info.component.html',
  styleUrl: './delete-info.component.scss'
})
export class DeleteInfoComponent implements OnInit {
  deletionForm: FormGroup;
  isSubmitting = false;
  showPassword = false;
  showModal = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {
    this.deletionForm = this.fb.group({
      confirmDelete: [false, Validators.requiredTrue],
      password: ["", [Validators.required, Validators.minLength(PASSWORD_MIN_LENGTH)]],
      email: ["", Validators.required]
    });
  }

  ngOnInit(): void {}

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    if (this.deletionForm.valid) {
      this.showModal = true;
    }
  }

  cancelDeletion(): void {
    this.showModal = false;
  }

  confirmDeletion(): void {
    this.isSubmitting = true;
    setTimeout(() => {
      this.isSubmitting = false;
      this.showModal = false;
      console.log("Profile deletion requested");
      this.toastr.success(`Your account deletion request has been received.`, `Request Sent`)
    }, 2000);
  }
}
